import { createSelector } from '@ngrx/store';

import { selectGlobalAppState, BannerNotificationStateKey } from '..';
import { selectFreePlanNotificationDismissed, selectIsFreemiumPlan } from '../billing/billing-state.selectors';

export namespace BannerStateSelectors {
  export const selectBannerNotificationState = createSelector(selectGlobalAppState, globalState =>
    globalState ? globalState[BannerNotificationStateKey] : null
  );
  export const selectMessage = createSelector(selectBannerNotificationState, banner => banner);

  //used by settings page to push the menu downward if there is a banner notification.
  //selectBannerNotificationState checks the old banner. remove that after fully moving to billing V3
  export const selectIsBannerVisible = createSelector(
    selectBannerNotificationState,
    selectIsFreemiumPlan,
    selectFreePlanNotificationDismissed,
    (banner, isFreemium, freePlanNotificationDismissed) => {
      return banner?.actionMessage?.length > 0 || (isFreemium && !freePlanNotificationDismissed);
    }
  );
}
